import { plainToClassFromExist } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TenantRequest } from '../model/tenant/tenant-request';
import { Tenant } from '../model/tenant/tenant.model';
import { PaginationResult } from '../model/pagination-result';

@Injectable()
export abstract class TenantService<TUser> {

  protected abstract tenantApiUrl: string;

  constructor(
    protected httpClient: HttpClient,
  ) { }

  addTenant(tenant: Tenant): Observable<TUser> {
    return this.httpClient.post<TUser>(this.tenantApiUrl + 'catalog/AddTenant', tenant);
  }

  getTenants(request: TenantRequest): Observable<PaginationResult<Tenant>> {
    return this.httpClient.post<PaginationResult<Tenant>>(this.tenantApiUrl + 'catalog/GetTenants', request).pipe(
      map(res => plainToClassFromExist(new PaginationResult<Tenant>(Tenant), res))
    );
  }

  toggleActive(tenantId: string): Observable<void> {
    return this.httpClient.post<void>(this.tenantApiUrl + `catalog/ToggleTenantActive/${tenantId}`, null);
  }

}
